import { computed } from 'vue'
import { useLocalStorage } from '@vueuse/core'
import { fetchMe } from '../data/pages/access'
import type { SessionUser } from '../pages/access/types'

// What the signed-in account may do: permission keys from touch-api (login / GET /v1/access/me).
// The API enforces every permission again; this only decides which menus, pages and buttons to show.
const stored = useLocalStorage<string[] | null>('userPermissions', null, {
  serializer: { read: (v) => (v ? JSON.parse(v) : null), write: (v) => JSON.stringify(v) },
})
const granted = computed(() => new Set(stored.value || []))

export const hasPermissions = () => stored.value !== null

// true when the account holds any of the keys
export const can = (...keys: string[]) => keys.some((k) => granted.value.has(k))

// Keeps the session in sync with the account (role edited by an admin, or a token from before permissions existed)
export const storeSession = (user: SessionUser & { token?: string }) => {
  if (user.token) localStorage.setItem('userToken', user.token)
  localStorage.setItem('userRole', String(user.role))
  localStorage.setItem('userInfo', JSON.stringify(user))
  stored.value = user.permissions || []
}

// Cost data (giá vốn, giá trị theo giá vốn): the API strips it without this permission, the screens hide the columns
export const canSeeCost = () => can('warehouse.cost.view')

export const refreshAccess = async () => {
  const me = await fetchMe()
  storeSession(me)
  return me
}

export const clearSession = () => {
  ;['userToken', 'userRole', 'userInfo'].forEach((key) => localStorage.removeItem(key))
  stored.value = null
}
